import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const ALLOWED = ["/hesap-tamamla", "/giris", "/kayit", "/sifremi-unuttum", "/sifre-sifirla",
  "/e-posta-dogrula", "/sayfa"];

/** Telefon + rol + il tamamlanmadan panel/uygulama kullanılamaz (personel hariç). */
export const ProfileGate = ({ children }) => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const exempt = ALLOWED.some((p) => pathname.startsWith(p));
  if (user && user.needs_profile && !exempt)
    return <Navigate to="/hesap-tamamla" replace state={{ from: pathname }} />;
  return children;
};
